import React, { Fragment } from 'react';

import { ReactComponent as InformationIcon } from '../../../assets/information.svg';
import { NumberUtils } from '../../../common/numberUtils';
import Skeleton from 'react-loading-skeleton';

export interface SectionListItemProps {
  title: string;
  caption?: string;
  value?: React.ReactNode;
  trailing?: React.ReactNode;
  onClickInfo?: () => void;
  isFetching?: boolean;
  dataTestId?: string;
}
export default function SectionListItem({
  title,
  caption,
  value,
  trailing,
  onClickInfo,
  isFetching,
  dataTestId,
}: SectionListItemProps) {
  return (
    <li className="section-list__list__item row" data-test-id={dataTestId}>
      <div className="section-list__list__item__label col-12 col-md-6">
        {isFetching ? (
          <Skeleton width={NumberUtils.randomInteger(100, 200)} />
        ) : (
          <Fragment>
            {title}
            {onClickInfo && (
              <InformationIcon
                onClick={onClickInfo}
                className="icon section-list__list__item__info-icon"
              />
            )}
            <div className="section-list__list__item__caption">{caption}</div>
          </Fragment>
        )}
      </div>
      <div className="section-list__list__item__value col-12 col-md-6">
        {isFetching ? (
          <Skeleton width={NumberUtils.randomInteger(100, 200)} />
        ) : (
          <Fragment>
            {value}
            {trailing}
          </Fragment>
        )}
      </div>
    </li>
  );
}
